import { render, staticRenderFns } from "./NavBarDivisor.vue?vue&type=template&id=2ee5e4cf&"
var script = {}
import style0 from "./NavBarDivisor.vue?vue&type=style&index=0&id=2ee5e4cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports